import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import Cookies from 'js-cookie';
import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';
import SnackBarContainer from '@panel/commons/lib/SimpleSnackbar/SnackBarContainer';
import SimpleTooltip from '@panel/commons/lib/Tooltip/SimpleTooltip';
import { ModalBase } from '@panel/commons';
import { getIsTransitionOrBundleCredit, exportPostingsQualityToExcel } from '@panel/commons/helpers';

import { PostingsOperations, PostingsSelectors } from '@panel/avisos/ducks/posting';
import SectionLayout from '../SectionLayout';
import { dataQualityAdapter } from '../dataQualityAdapter';
import ChevronDownIcon from '../../assets/icons/chevron_right.svg';
import { ReputationSelectors } from '../../ducks/reputation';
import { dataRatingsAdapter } from '../dataRatingsAdapter';
import EmptyStateScore from '../EmptyStateScore';
import { Modal } from '../Modals/ModalWrapper';
import ProgressBar from '../ProgressBar';

import HighIconFace from '../../assets/icons/highFaceIcon.svg';
import MediumIconFace from '../../assets/icons/mediumFaceIcon.svg';
import LowIconFace from '../../assets/icons/lowFaceIcon.svg';
import NoDataIconFace from '../../assets/icons/noDataFaceIcon.svg';
import {
  Container,
  Icon,
  TitleText,
  TooltipComponent,
  MainArea,
  LeftSide,
  RightSide,
  ProgressBarContainer,
  ProgressBarRow,
  BottomSheetTitle,
  MoreComments,
  ChevronDown,
  ModalContainer,
  ContainerQuality,
  CircleChart,
  TitleContainer,
  BajadaContainer,
  ContainerModalBody,
  QualityText,
  QualityContainer,
  ButtonContainer,
  InfoLevel,
  Secondary,
  HeaderSectionContainer,
  MobileBajadaContainer,
  SpanText,
  LinkToDownloadPostingsQuality,
  MobileBajadaContainerModal
} from './styles';
import './buttonSheetStyles.css';

import {
  getLevelInfo,
  ReturnLevelIcon,
  getLevelBackground,
  getLevelTaxColour,
  getLevelInfoByPercent,
  getLevelSubtitleBypercent
} from '../../helpers/utils';

const PublisherQualitySection = ({ device, reloadDispatch, sendCustomTrackingInfo, branchId }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isMobile = device === 'mobile';
  const isTablet = device === 'tablet';
  const [ratingsData, setRatingsData] = useState({});
  const [progressBarData, setProgressBarData] = useState([]);
  const [openBottomSheet, setOpenBottomSheet] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const [showSnackBar, setShowSnackBar] = useState(false);
  const snackBarTextBuilder = (action, result) => {
    if (action === 'downloadPostingsQuality') {
      if (result === 'SUCCESS') {
        return t('panel.quality.generalData.downloadingData.success');
      }
      if (result === 'INFO') {
        return t('panel.quality.generalData.CTA.reputation.loading');
      }
      if (result === 'ERROR') {
        return t('panel.quality.generalData.downloadingData.error');
      }
    }

    return t(`panel.avisos.${action}.snackbar.${result}`);
  };
  const [finishedAction, setFinishedAction] = useState({
    postingId: '',
    action: '',
    result: '',
    isParticularNotFree: false
  });

  const { ratings, reports, ratingsError } = useSelector(ReputationSelectors.getReputationState);
  // calidad
  const [active, setActive] = useState('');
  const [qualityData, setQualityData] = useState(null);
  const { quality, qualityError } = useSelector(ReputationSelectors.getReputationState);
  const { qualityValue, totalOnlinePostings, valueHigh, valueMedium, valueLow, valueNoData } = qualityData || {};
  const isFull = qualityValue === 1000;
  const [level, setLevel] = useState(0);
  const { fetchPostingsQualityToExport, resetPostingsQualityToExport } = PostingsOperations;
  const {
    postingsQualityToExport,
    postingsQualityToExportCompleted,
    postingsQualityToExportFailed,
    postingsQualityToExportIsLoading
  } = useSelector(PostingsSelectors.getPostingsState);
  const { notRespondedCount } = ratingsData;

  const cookieExportPostingsQualityToExcel = !!Cookies.get(`exportPostingsQualityToExcel-Reputation-${branchId}`);

  const downloadPostingsQualityCallback = () => {
    dispatch(fetchPostingsQualityToExport(branchId));
  };

  useEffect(() => {
    // Seteamos con timeout para que no se superpongan las snackbars.
    if (postingsQualityToExportIsLoading) {
      setFinishedAction({
        postingId: '',
        action: 'downloadPostingsQuality',
        result: 'INFO',
        component: snackBarTextBuilder('downloadPostingsQuality', 'INFO'),
        keepOpen: false
      });
      setShowSnackBar(true);
      setTimeout(() => {
        setShowModal(false);
        setShowSnackBar(false);
      }, 2000);
    }
    if (postingsQualityToExportCompleted && postingsQualityToExport.postings.length === 0) {
      setTimeout(() => {
        setFinishedAction({
          postingId: '',
          action: 'downloadPostingsQuality',
          result: 'INFO',
          component: t('panel.quality.generalData.downloadingData.notData'),
          keepOpen: false
        });
        setShowSnackBar(true);
        setTimeout(() => {
          setShowSnackBar(false);
          dispatch(resetPostingsQualityToExport());
        }, 2000);
      }, 2000);
    }

    if (
      (postingsQualityToExportCompleted && postingsQualityToExport.postings.length > 0) ||
      postingsQualityToExportFailed
    ) {
      setTimeout(() => {
        setFinishedAction({
          postingId: '',
          action: 'downloadPostingsQuality',
          result: postingsQualityToExportFailed ? 'ERROR' : 'SUCCESS',
          component: snackBarTextBuilder(
            'downloadPostingsQuality',
            postingsQualityToExportFailed ? 'ERROR' : 'SUCCESS'
          ),
          keepOpen: false
        });
        setShowSnackBar(true);
        setTimeout(() => {
          setShowSnackBar(false);
          dispatch(resetPostingsQualityToExport());
        }, 2000);
      }, 2000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postingsQualityToExportCompleted, postingsQualityToExportFailed, postingsQualityToExportIsLoading]);

  useEffect(() => {
    if (postingsQualityToExportCompleted) {
      if (postingsQualityToExport.postings.length > 0) {
        const adaptedExportData =
          postingsQualityToExport &&
          postingsQualityToExport.postings.map(postingData => {
            const isTransitionOrBundleCredit =
              postingData.publicationPlanId && getIsTransitionOrBundleCredit(postingData.publicationPlanId);
            const dataToPostingsExport = {
              [t('panel.quality.generalData.IdAviso')]: postingData.postingId,
              [t('panel.quality.generalData.codigo')]: postingData.code,
              [t('panel.quality.generalData.tipoPropiedad')]: postingData.realEstateTypeName,
              [t('panel.quality.generalData.tituloAviso')]: postingData.title,
              [t('panel.quality.generalData.precio')]: postingData.opTypeAndPrices,
              [t('panel.quality.generalData.fechaInicio')]: postingData.beginDate,
              [t('panel.quality.generalData.plan')]: isTransitionOrBundleCredit
                ? postingData.publicationPlanName
                : t(`panel.avisos.planName.${postingData.publicationPlan}`),
              [t('panel.quality.generalData.updateLink')]: `${window.location.origin}${postingData.urlEditPosting}`,
              [t('panel.quality.generalData.porcentajePanoramix')]: postingData.percentageCorrectness
            };
            for (let i = 1; i <= postingsQualityToExport.maxTips; i += 1) {
              if (i <= postingsQualityToExport.maxTips) {
                dataToPostingsExport[`${t('panel.quality.generalData.consejoPanoramix', { value: i })}`] = postingData
                  .qualityTips[`${i} Advice`]
                  ? postingData.qualityTips[`${i} Advice`]
                  : '';
              }
            }
            return dataToPostingsExport;
          });
        const newDate = `${new Date().getFullYear()}${new Date().getMonth() + 1}${new Date().getDate()}`;
        const filName = `${t('panel.quality.generalData.DocumentName')}-${branchId}-${newDate}`;
        exportPostingsQualityToExcel(adaptedExportData, filName);
      }
      sendCustomTrackingInfo({
        event: 'select_content',
        content_type: 'Estadisticas - Reputación',
        item_id: 'Descargar Archivo'
      });
      Cookies.set(`exportPostingsQualityToExcel-Reputation-${branchId}`, true, { expires: 1 });
    }
  }, [branchId, postingsQualityToExport, postingsQualityToExportCompleted, sendCustomTrackingInfo, t]);

  useEffect(() => {
    if (ratings) setRatingsData(dataRatingsAdapter(ratings));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ratings]);

  useEffect(() => {
    if (quality) setQualityData(dataQualityAdapter(quality));
    if (!qualityError && quality.percentage_correctness !== null) {
      setLevel(getLevelInfoByPercent(quality.percentage_correctness));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quality]);

  const handleClick = () => {
    sendCustomTrackingInfo({
      event: 'select_content',
      content_type: 'Estadisticas - Reputación',
      item_id: 'Ver avisos a completar'
    });

    window.open(`${window.location.origin}/panel/avisos?hasQuality=true`);
  };

  const handleClickReport = () => {
    sendCustomTrackingInfo({
      event: 'select_content',
      content_type: 'Estadisticas - Reputación',
      item_id: 'Ver reportes'
    });

    window.open(`${window.location.origin}/panel/avisos?hasReportsTotal=true`);
  };

  useEffect(() => {
    setProgressBarData([
      { id: 'high', value: valueHigh, color: 'accessibleGreen', icon: HighIconFace },
      { id: 'medium', value: valueMedium, color: 'yellow', icon: MediumIconFace },
      { id: 'low', value: valueLow, color: 'negative', icon: LowIconFace },
      { id: 'noData', value: valueNoData, color: 'midDarkGray', icon: NoDataIconFace }
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [qualityData]);

  const getTextInsideCircle = value => {
    if (value)
      return (
        <text x='18' y='21.3' className='percentage'>
          {Math.round(value)}%
        </text>
      );
    if (typeof value === 'number' && value === 0)
      return (
        <text x='18' y='20.35' className='label'>
          {t('panel.reputacion.quality.avgQuality.noQuality')}
        </text>
      );
    if (!value || !Number.isNaN(value))
      return (
        <text x='18' y='20.35' className='label_noQuality'>
          {t('panel.reputacion.quality.avgQuality.noQuality')}
        </text>
      );
    return '';
  };

  const setQuality = value => {
    if (!value && typeof value === 'number' && value === 0) return 'noData';
    if (value && value >= 90) return 'high';
    if (value && value >= 80 && value < 90) return 'medium';
    if (value && value < 80) return 'low';
    return 'noQuality';
  };

  const percentProgressBar = (valueQuality, totalElements) => {
    if (!valueQuality) return '0';
    let percentage = '0';
    if (valueQuality <= totalElements) {
      percentage = (parseInt(valueQuality) * 100) / totalElements;
    }
    if (valueQuality > totalElements) return '100';
    return percentage;
  };

  const tooltipComponent = (valueQuality, totalElements) => {
    return (
      <TooltipComponent width='146px' height='44px'>
        {t(`panel.estadisticas.quality.textBar.tooltip${valueQuality === 1 ? '' : '.plural'}`, {
          value1: valueQuality || '0',
          value2: totalElements || '0'
        })}
      </TooltipComponent>
    );
  };

  const getTopEmptyState = () => {
    if (device === 'mobile') return '20px';
    if (device === 'desktop') return '0px';
    return '30px';
  };

  return (
    <SectionLayout
      data-panel='panel-estadisticas-ratings'
      marginTop='0px'
      paddingBottom={notRespondedCount ? '24' : 24}
    >
      {device === 'desktop' && (
        <Container>
          {!ratingsError ? (
            <MainArea device={device} notRespondedCount={notRespondedCount}>
              <LeftSide device={device} data-panel='ratings-container-leftSide'>
                <TitleContainer> {t('panel.reputacion.calidad.title')}</TitleContainer>
                <BajadaContainer device={device}> {t(getLevelSubtitleBypercent(level))}</BajadaContainer>

                {progressBarData && ((isMobile && progressBarData.length > 0) || progressBarData.length > 0) && (
                  <MoreComments
                    device={device}
                    onClick={() => {
                      if (isMobile || isTablet) setOpenBottomSheet(true);
                      if (!isMobile && !isTablet) setShowModal(true);
                      sendCustomTrackingInfo({
                        event: 'select_content',
                        content_type: 'Estadisticas - Reputación',
                        item_id: 'Conocer Calidad'
                      });
                    }}
                  >
                    {t('panel.reputacion.calidad.cta')}
                    <ChevronDown
                      data-panel='ratings-moreComments-chevron'
                      src={showModal || openBottomSheet ? ChevronDownIcon : ChevronDownIcon}
                      alt='chevron-down'
                    />
                  </MoreComments>
                )}
              </LeftSide>
              <RightSide device={device} data-panel='ratings-container-rightSide'>
                {quality.percentage_correctness && (
                  <InfoLevel background={getLevelBackground(level)} color={getLevelTaxColour(level)}>
                    <Icon data-panel=''>{ReturnLevelIcon(level)}</Icon>
                    {t(getLevelInfo(level || 0))}
                  </InfoLevel>
                )}

                <ContainerQuality device={device} qualityStatus={setQuality(qualityValue)}>
                  <CircleChart
                    qualityStatus={setQuality(qualityValue)}
                    qualityNotApply={setQuality(qualityValue) === 'noQuality'}
                    data-panel='panel-reputation-quality-circleChart'
                    isFull={isFull}
                  >
                    <div className='single-chart'>
                      <svg viewBox='0 0 36 36' className='circular-chart blue'>
                        <path
                          className='circle-bg'
                          d='M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831'
                        />
                        <path
                          className='circle'
                          strokeDasharray={`${Math.round(qualityValue)}, 100`}
                          d='M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831'
                        />
                        {getTextInsideCircle(qualityValue)}
                      </svg>
                    </div>
                    <div className='icon-container'>
                      <div className='face-icon' />
                    </div>
                  </CircleChart>
                </ContainerQuality>
              </RightSide>
              {showModal && !isMobile && (
                <Modal>
                  <ModalBase
                    openModal={showModal}
                    onClose={() => setShowModal(false)}
                    width='588px'
                    height='350px'
                    rightPosition='25px'
                    topPosition='25px'
                  >
                    <ModalContainer>
                      <TitleText data-panel='ratings-moreComments-modal-calidad-title' mBottom='24px' fontSize='20px'>
                        {t('panel.reputacion.calidad.modal.title')}
                      </TitleText>
                      <BajadaContainer device={device}> {t('panel.reputacion.calidad.modal.bajada')}</BajadaContainer>
                      <ContainerModalBody>
                        <QualityContainer>
                          {progressBarData &&
                            progressBarData.map((element, i) => {
                              return (
                                <ProgressBarContainer
                                  device={device}
                                  key={i.toString()}
                                  onMouseEnter={() => {
                                    if (totalOnlinePostings && totalOnlinePostings >= 0) setActive(element.id);
                                  }}
                                  onMouseLeave={() => {
                                    setActive('');
                                  }}
                                >
                                  <QualityText
                                    device={device}
                                    data-panel={`progressBar-text-quality-${element.id}`}
                                    hoverActive={active === element.id}
                                  >
                                    <div className='progressBar-title'>
                                      {t(`panel.estadisticas.quality.textBar.${element.id}`)}
                                    </div>
                                    <img
                                      className='image-faces'
                                      src={element.icon}
                                      alt={`icon-face-${element.id}`}
                                      data-panel={`icon-face-${element.id}`}
                                    />
                                  </QualityText>
                                  <ProgressBarRow device={device} hoverActive={active === element.id}>
                                    <ProgressBar
                                      fillValue={percentProgressBar(element.value, totalOnlinePostings)}
                                      dataPanel='quality'
                                      filledColor='midDarkGrayAux'
                                      emptyColor='neutralDarkGray'
                                      hoverColor={element.color}
                                      tooltipComponent={tooltipComponent(element.value, totalOnlinePostings)}
                                      hoverActive={active === element.id}
                                      totalOnlinePostings={totalOnlinePostings}
                                    />
                                    <div className='containerValue'>
                                      <div className='value' data-panel={`progressBar-quality-value-${element.id}`}>
                                        {element.value || '0'}
                                      </div>
                                    </div>
                                  </ProgressBarRow>
                                </ProgressBarContainer>
                              );
                            })}
                        </QualityContainer>
                      </ContainerModalBody>

                      <ButtonContainer>
                        <Secondary onClick={handleClick}>{t('panel.reputacion.calidad.modal.cta')}</Secondary>
                      </ButtonContainer>
                      {reports.totalReports && reports.totalReports > 0 && (
                        <BajadaContainer device={device}>
                          {' '}
                          {t('panel.reputacion.calidad.modal.reportes', { value: reports.totalReports })}
                          <SpanText onClick={handleClickReport}>
                            {t('panel.reputacion.calidad.modal.text.reportes')}
                          </SpanText>
                        </BajadaContainer>
                      )}

                      {(valueMedium > 0 || valueLow > 0) && (
                        <SimpleTooltip
                          // Solo se muestra el tooltip despues de desacargarse el archivo y dentro de las 24hs que esta seteada la Cookie.
                          showChildren={cookieExportPostingsQualityToExcel}
                          offset={10}
                          delay={100}
                          delayOut={200}
                          position='bottom-center'
                          text={t('panel.quality.generalData.CTA.tooltip.success')}
                          dataPanel='tooltip-interactive-link-calidad-downloadQuality'
                        >
                          <LinkToDownloadPostingsQuality
                            downloaded={cookieExportPostingsQualityToExcel}
                            data-panel='ratings-modal-calidad-downloadQuality'
                            onClick={downloadPostingsQualityCallback}
                          >
                            {t('panel.quality.generalData.CTA.reputation')}
                          </LinkToDownloadPostingsQuality>
                        </SimpleTooltip>
                      )}
                    </ModalContainer>
                  </ModalBase>
                </Modal>
              )}
            </MainArea>
          ) : (
            <EmptyStateScore
              withSpacing={device === 'desktop'}
              height={isMobile ? '160px' : '115px'}
              top={getTopEmptyState()}
              callback={reloadDispatch}
              text={t('panel.reputacion.calidad.title')}
            />
          )}
        </Container>
      )}

      {!ratingsError && device !== 'desktop' && (
        <Container>
          <HeaderSectionContainer>
            <TitleContainer>{t('panel.reputacion.calidad.title')}</TitleContainer>
            {quality.percentage_correctness && (
              <InfoLevel background={getLevelBackground(level)} color={getLevelTaxColour(level)}>
                <Icon data-panel=''>{ReturnLevelIcon(level)}</Icon>
                {t(getLevelInfo(level || 0))}
              </InfoLevel>
            )}
          </HeaderSectionContainer>

          <MobileBajadaContainer>{t('panel.reputacion.calidad.bajada')}</MobileBajadaContainer>

          <HeaderSectionContainer>
            <ContainerQuality device={device} qualityStatus={setQuality(qualityValue)}>
              <CircleChart
                qualityStatus={setQuality(qualityValue)}
                qualityNotApply={setQuality(qualityValue) === 'noQuality'}
                data-panel='panel-reputation-quality-circleChart'
                isFull={isFull}
              >
                <div className='single-chart'>
                  <svg viewBox='0 0 36 36' className='circular-chart blue'>
                    <path
                      className='circle-bg'
                      d='M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831'
                    />
                    <path
                      className='circle'
                      strokeDasharray={`${Math.round(qualityValue)}, 100`}
                      d='M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831'
                    />
                    {getTextInsideCircle(qualityValue)}
                  </svg>
                </div>
                <div className='icon-container'>
                  <div className='face-icon' />
                </div>
              </CircleChart>
            </ContainerQuality>
            {progressBarData && ((isMobile && progressBarData.length > 0) || progressBarData.length > 0) && (
              <MoreComments
                onClick={() => {
                  if (isMobile || isTablet) setOpenBottomSheet(true);
                  if (!isMobile && !isTablet) setShowModal(true);
                  sendCustomTrackingInfo({
                    event: 'select_content',
                    content_type: 'Estadisticas - Reputación',
                    item_id: 'Conocer Calidad'
                  });
                }}
                device={device}
              >
                {t('panel.reputacion.calidad.cta')}
                <ChevronDown
                  data-panel='ratings-moreComments-chevron'
                  src={showModal || openBottomSheet ? ChevronDownIcon : ChevronDownIcon}
                  alt='chevron-down'
                />
              </MoreComments>
            )}
          </HeaderSectionContainer>

          {(isMobile || isTablet) && (
            <BottomSheet
              open={openBottomSheet}
              onDismiss={() => setOpenBottomSheet(false)}
              snapPoints={({ maxHeight }) => [maxHeight / 1.12]}
              header={React.createElement(
                'div',
                {},
                <BottomSheetTitle data-panel='ratings-bottomSheet-title'>
                  {t('panel.reputacion.calidad.title')}
                </BottomSheetTitle>
              )}
            >
              <MobileBajadaContainerModal>
                <BajadaContainer> {t('panel.reputacion.calidad.modal.bajada')}</BajadaContainer>
              </MobileBajadaContainerModal>

              <ContainerModalBody
                style={{
                  paddingLeft: '16px',
                  paddingRight: '16px'
                }}
              >
                <QualityContainer
                  style={{
                    width: '100%'
                  }}
                >
                  {progressBarData &&
                    progressBarData.map((element, i) => {
                      return (
                        <ProgressBarContainer
                          device={device}
                          key={i.toString()}
                          onMouseEnter={() => {
                            if (totalOnlinePostings && totalOnlinePostings >= 0) setActive(element.id);
                          }}
                          onMouseLeave={() => {
                            setActive('');
                          }}
                        >
                          <QualityText
                            device={device}
                            data-panel={`progressBar-text-quality-${element.id}`}
                            hoverActive={active === element.id}
                          >
                            <div className='progressBar-title'>
                              {t(`panel.estadisticas.quality.textBar.${element.id}`)}
                            </div>
                            <img
                              className='image-faces'
                              src={element.icon}
                              alt={`icon-face-${element.id}`}
                              data-panel={`icon-face-${element.id}`}
                            />
                          </QualityText>
                          <ProgressBarRow device={device} hoverActive={active === element.id}>
                            <ProgressBar
                              fillValue={percentProgressBar(element.value, totalOnlinePostings)}
                              dataPanel='quality'
                              filledColor='midDarkGrayAux'
                              emptyColor='neutralDarkGray'
                              hoverColor={element.color}
                              tooltipComponent={tooltipComponent(element.value, totalOnlinePostings)}
                              hoverActive={active === element.id}
                              totalOnlinePostings={totalOnlinePostings}
                            />
                            <div className='containerValue'>
                              <div className='value' data-panel={`progressBar-quality-value-${element.id}`}>
                                {element.value || '0'}
                              </div>
                            </div>
                          </ProgressBarRow>
                        </ProgressBarContainer>
                      );
                    })}
                </QualityContainer>
              </ContainerModalBody>

              <ButtonContainer>
                <Secondary onClick={handleClick}>{t('panel.reputacion.calidad.modal.cta')}</Secondary>
              </ButtonContainer>
              {reports.totalReports && reports.totalReports > 0 && (
                <BajadaContainer device={device}>
                  {' '}
                  {t('panel.reputacion.calidad.modal.reportes', { value: reports.totalReports })}
                  <SpanText onClick={handleClickReport}>{t('panel.reputacion.calidad.modal.text.reportes')}</SpanText>
                </BajadaContainer>
              )}
              {(valueMedium > 0 || valueLow > 0) && (
                <SimpleTooltip
                  // Solo se muestra el tooltip despues de desacargarse el archivo y dentro de las 24hs que esta seteada la Cookie.
                  showChildren={cookieExportPostingsQualityToExcel}
                  offset={0}
                  delay={100}
                  delayOut={200}
                  position='bottom-center'
                  text={t('panel.quality.generalData.CTA.tooltip.success')}
                  dataPanel='tooltip-interactive-link-calidad-downloadQuality'
                >
                  <LinkToDownloadPostingsQuality
                    downloaded={cookieExportPostingsQualityToExcel}
                    data-panel='ratings-modal-calidad-downloadQuality'
                    onClick={downloadPostingsQualityCallback}
                  >
                    {t('panel.quality.generalData.CTA.reputation')}
                  </LinkToDownloadPostingsQuality>
                </SimpleTooltip>
              )}
            </BottomSheet>
          )}
        </Container>
      )}

      {ratingsError && device !== 'desktop' && (
        <EmptyStateScore
          withSpacing={device === 'desktop'}
          height={isMobile ? '160px' : '115px'}
          callback={reloadDispatch}
          text={t('panel.reputacion.calidad.title')}
        />
      )}

      {showSnackBar && (
        <Modal>
          <SnackBarContainer action={finishedAction} deviceType={device !== 'mobile' ? 'desktop' : 'mobile'} />
        </Modal>
      )}
    </SectionLayout>
  );
};

export default PublisherQualitySection;
